export default __webpack_public_path__ + "static/media/Frame1.1aad6f07.png";